import CloseIcon from "@mui/icons-material/Close";
import { Divider, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch } from "react-redux";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import ViewTransaction from "../Invitations/ViewTransaction";

const BootstrapDialog = styled(Dialog)(({ theme, darkMode }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    overflowY: "clip",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    overflowY: "visible",
    borderRadius: "20px",
    minWidth: "80vh",
    height: "400px",
    opacity: 1,
    backgroundColor: darkMode ? "#0E2A41" : "#FFFFFF",
  },
  "& .MuiDialogContent-root ": {
    padding: "16px 24px",
    position: "relative",
    bottom: "80px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, darkMode, ...other } = props;
  const { t } = useTranslation();

  return (
    <DialogTitle {...other} id="form-dialog-title" variant="h4">
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
      <Typography
        variant="h4"
        style={{
          color: props.darkMode ? "#fff" : "black",
        }}
      >
        {t("Transaction History")}
      </Typography>
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function TransactionHistory(props) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const dataMap = props.rowData.visitorTransactions;
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);

  const handleClickOpen = () => {
    loadTransactions();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const scrollbarStyle = {
    height: "258px",
  };

  const loadTransactions = () => {
    axios.get("/web/transaction/list/" + props.rowData.id).then((res) => {
      if (res.data.code === "CVAI0000") {
        setData(res.data.data);
      }
    });
  };

  const dateFormat = props.date;

  return (
    <div>
      <div
        onClick={handleClickOpen}
        style={
          {
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }
        }
      >
        <ViewTransaction />
      </div>
      <Grid>
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={open}
          darkMode={darkMode}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <BootstrapDialogTitle
            onClose={handleClose}
            darkMode={darkMode}
          ></BootstrapDialogTitle>
          <Divider
            variant="middle"
            style={{
              background: darkMode
                ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
                : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
              height: "1px",
              opacity: 0.5,
            }}
          />

          <DialogContent style={{ bottom: "14px", paddingTop: "24px" }}>
            <Grid
              container
              spacing={2}
              className="transactionHistoryStyles"
              style={{
                whiteSpace: "nowrap",
                color: darkMode ? "white" : "",
                paddingBottom: "10px",
                position: "sticky",
              }}
            >
              <Grid item sm={6}>
                {t("DATE_TIME")}
              </Grid>
              <Grid item sm={6}>
                {t("CHECK_IN_AND_CHECK_OUT")}
              </Grid>
            </Grid>
            <PerfectScrollbar
              options={{ wheelPropagation: true }}
              style={scrollbarStyle}
            >
              {Array.isArray(data) &&
                data
                  .sort(
                    (a, b) =>
                      moment(a.transactionDateAndTime).valueOf() -
                      moment(b.transactionDateAndTime).valueOf(),
                  )
                  .map((transaction) => (
                    <Grid
                      container
                      key={transaction.id}
                      spacing={2}
                      style={{
                        paddingBottom: "10px",
                        overflow: "auto",
                      }}
                    >
                      <Grid
                        item
                        xs={6}
                        style={{
                          whiteSpace: "nowrap",
                          color: darkMode ? "white" : "",
                        }}
                      >
                        {dateFormat === "MM-dd-yyyy HH:mm"
                          ? moment(
                              CommonUtil.getLocalDateTimeInYearFormat(
                                transaction.transactionDateAndTime,
                              ),
                            ).format("MM-DD-YYYY HH:mm")
                          : dateFormat === "dd-MM-yyyy HH:mm"
                          ? moment(
                              CommonUtil.getLocalDateTimeInYearFormat(
                                transaction.transactionDateAndTime,
                              ),
                            ).format("DD-MM-YYYY HH:mm")
                          : dateFormat === "yyyy-MM-dd HH:mm"
                          ? moment(
                              CommonUtil.getLocalDateTimeInYearFormat(
                                transaction.transactionDateAndTime,
                              ),
                            ).format("YYYY-MM-DD HH:mm")
                          : ""}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sx={{
                          color: darkMode ? "white" : "",
                        }}
                      >
                        {transaction.transactionStatus}
                      </Grid>
                    </Grid>
                  ))}
            </PerfectScrollbar>
          </DialogContent>
        </BootstrapDialog>
      </Grid>
    </div>
  );
}

export default TransactionHistory;
